<template>
	<div class="flex-1 flex flex-col">
		<div class="flex-1">
			<div class="flex justify-between mt-6">
				<div>
					<h2 class="flex items-center space-x-4 px-2 font-bold text-2xl text-black">
						<span class="text-base">Order value:</span> <span>R {{ orderValue }}</span>
					</h2>					
				</div>
				<div class="flex space-x-4">
					<button class="flex items-center whitespace-nowrap space-x-2  px-4 py-2 text-lg rounded px-2 py-1 bg-blue-600 hover:bg-blue-700 text-white" @click="deliveryDates = !deliveryDates">
						<clock-icon class="w-5 h-5"></clock-icon>
						<span>Delivery / Invoice Dates</span>
					</button>
				</div>
			</div>
			<div class="divide-y" v-if="jobs.length" v-for="(job, index) in jobs">
				<div class="flex items-center justify-between p-2 py-2 bg-gray-200 mt-2" @click="toggleJob(index)">
					<div class="flex items-center space-x-4">
						<input type="checkbox" class="form-checkbox h-6 w-6 ml-3 border-blue-400" :name="`submit-${job.job}`" :value="job.job" v-model="submitJobs" @click.stop="">
						<h2 class="text-xl font-bold">{{ job.job }}</h2>
					</div>
					<p class="font-bold" v-if="showJob !== index">R{{ job.total_format }}</p>
				</div>
				<div class="bg-gray-200" v-if="showJob == index">
					<div class=" divide-y" v-for="(products, sec) in job.orders" v-if="products.length">
						<div class="flex items-center bg-gray-600 text-white px-2 py-1 text-sm" :class="[jobSections.includes(job.id+sec) ? '' : 'justify-between']" @click="toggleJobSection(job.id+sec)">
							<div class="w-64 flex-shrink-0">
								{{ categories[sec] }}
							
							</div>
							<div class="flex-1 flex-shrink-0" v-if="jobSections.includes(job.id+sec)">
								details
							</div>
							<div class="w-20 flex-shrink-0 text-right" v-if="jobSections.includes(job.id+sec)">
								ordered
							</div>
							<div class="w-24 flex-shrink-0 text-right" v-if="jobSections.includes(job.id+sec)">
								wh total
							</div>
							<div class="w-24 flex-shrink-0 text-right" v-if="jobSections.includes(job.id+sec)">
								sup total
							</div>
							<div class="w-28 flex-shrink-0 text-right">
								total {{ sectionTotal(products) | toCurrency }}
							</div>
						</div>
						<div class="flex items-center py-1 bg-white text-sm" v-for="product in products" v-if="jobSections.includes(job.id+sec)">
							<div class="px-2 w-64 flex-shrink-0">
								{{ product.product }}
							</div>
							<div class="flex-1 flex items-center divide-x flex-shrink-0">
								<div class="text-sm text-center px-1 leading-none" v-for="(details, section) in product.section">
									<p>{{ section }}</p>
									<p>{{ details.ordered }}</p>
									<!-- <p>{{ details.total }}</p> -->
								</div>
							</div>
							<div class="w-20 flex-shrink-0 text-right">
								{{ product.ordered }}
							</div>
							<div class="w-24 flex-shrink-0 text-right">
								R {{ product.warehouse_total }}
							</div>
							<div class="w-24 flex-shrink-0 text-right">
								R {{ product.supplier_total }}
							</div>
							<div class="w-28 flex-shrink-0 text-right font-bold">
								<p class="px-2">R {{ product.total }}</p>
							</div>
						</div>			
					</div>
					<div class="flex justify-end">
						<div class="flex-1 px-2 py-1 font-bold text-lg border-black border-t border-b-2 text-right">
							Total: R{{ job.total_format }}
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="mt-4 bg-green-400 py-4 bg-green-600" v-if="(role=='Super Admin' || role=='Accounts')">
			<action-button class="flex w-full justify-center text-white" @button-clicked="submit" :disabled="!submitJobs.length">
				<clipboard-icon class="w-5 h-5 mr-1"></clipboard-icon>
				<span>Submit Order</span>
			</action-button>
		</div>
		<portal to="modals" v-if="deliveryDates" :order="1">
			<delivery-dates-modal
				:show="deliveryDates"			
				:regionid="regionid"
				@close="deliveryDates = false"
				@save="saveDeliveryDates"
				@reload="$emit('reload')"
				>
			</delivery-dates-modal>
		</portal>
	</div>
</template>

<script>
import {formatDistance, parseISO} from 'date-fns';
import DeliveryDatesModal from '../../components/common/DeliveryDatesModal.vue'
export default {
	name: 'ReviewProcessedRegionForecasts',
	data () {
		return {
			regionid:this.$route.params.regionid,
			jobs: [],
			reviewComments: [],
			showJob: null,
			deliveryDates: false,
			sectionName: {
				carport: 'Phase',
				common: 'Block',
				final_fix: 'Unit',
				final_fix_gen: 'Phase',
				first_fix: 'Block',
				reticulation: 'Area',
				reticulation_general: 'Phase',
				special_area: 'Area',
				tools: 'Job',
				wire: 'Block',
			},
			categories: {
				reticulation: 'Reticulation',
				reticulation_general: 'Reticulation General',
				first_fix: 'First Fix',
				wire: 'Wire',
				final_fix: 'Final Fix',
				common: 'Common',
				carport: 'Carports',
				tools: 'Tools and Consumables',
				specialareas: 'Special Areas',
				none: 'Not specified',
			},
			displayProducts: {},
			sectionNames: {},
			unitProductBreakDown: [],
			units: {},
			submitJobs: [],
			jobSections: [],
		}
	},
	computed: {
		forecasts: function(){
			let jobs = this.jobs.filter(job => this.submitJobs.includes(job.job));
			return this.$_(jobs).flatMap(job => {
				let supplierOrders = this.$_(job.orders).filter(order => order.length).flatMap().flatMap(product => {
					return this.$_(product.suppliers).flatMap(supplier => supplier.forecast_orders).value();
				}).value();
				let warehouseOrders = this.$_(job.orders).filter(order => order.length).flatMap().flatMap(product => {
					return this.$_(product.warehouse).flatMap(warehouse => warehouse.forecast_orders).value();
				}).value();
				return supplierOrders.concat(warehouseOrders);
			}).value();
		},
		orderValue: function(){
			let jobs = this.jobs.filter(job => this.submitJobs.includes(job.job));
			return jobs.reduce((initial, job) => initial + job.total, 0);
		},
		role: function(){
			return this.$store.getters['auth/role'];
		},
	},
	methods: {
		toggleJob(index) {
			if(this.showJob == index){
				this.showJob = null;
				return;
			}
			this.showJob = index;
		},
		toggleJobSection: function(section){
			let theIndex = this.jobSections.indexOf(section);
			if(theIndex == -1){
				this.jobSections.push(section);
				return;
			}
			this.jobSections.splice(theIndex, 1);
		},
		sectionTotal: function (products) {
			return products.reduce( function(a, b){
				return a + Number(b['total']);
			}, 0);
		},
		daysFrom: function(dateString){
			return formatDistance(parseISO(dateString, 'yyyy-MM-dd HH:mm:ss', new Date()), new Date(), { addSuffix: true });
		},
		categoryByKey: function(key){
			let cat = this.$store.getters.getProductCategoryNameByKey(key);
			return cat ? cat : key.charAt(0).toUpperCase() + key.slice(1);
		},
		checkJobs: function(){
			this.jobs.forEach(job => {
				console.log(job.job);
				this.submitJobs.push(job.job)
			});
		},
		saveDeliveryDates: function () {
			console.log();
		},
		reload: function () {
			// console.log('here');
			this.$http.get(`forecast/${this.regionid}/review`)
				.then(response => {
                    this.jobs = response.data.jobs;
                    if(this.jobs.length == 1){
                    	//this.showJob = 0;
                    }
                    this.checkJobs()
				})
				.catch(err => {
					this.error = err
				})
		},
		submit: function(){
			this.$http.post(`forecasts/${this.regionid}/submit`, {
				forecastOrders: this.forecasts
			}).then(response => {
					let success = {
						title: 'Action Successful',
						message: response.data.message,
						type: 'success'
					}
					this.$store.commit('setStatus', success)
					this.$router.go(-1);
				})
		}
	},
	components: {
		DeliveryDatesModal
	},
	created: function () {
		this.$store.commit('setJobName', null)
		// console.log('here11');
		this.reload()
	}
}
</script>
